import { PieChart, pieArcLabelClasses  } from '@mui/x-charts/PieChart';
import * as React from 'react';

const defaultSoilComposition = [
    
    { id: 0, value: 2, label: 'Akadama' },
    { id: 1, value: 1, label: 'Pumice' },
    { id: 2, value: 2, label: 'Pine Bark' },
];

export default function BonsaiSoilCompositionGraph({ soilComposition = defaultSoilComposition }) {

    return (
        
        <PieChart 
        // show the amount of each

        series={[{ 
            arcLabel: (item) => `${item.value}`,
            data: soilComposition }]} width={400} height={200}
            sx={{
                [`& .${pieArcLabelClasses.root}`]: {
                  fill: 'white',
                  fontWeight: 'bold',
                },
              }}
             />
    );
}
